import React from 'react';
import { StarIcon, ShieldCheckIcon, ZapIcon, FileTextIcon, LockIcon } from 'lucide-react';
import { Button } from './Button';
export function HeroSection() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-20 pb-12 md:pt-24 md:pb-16 bg-gradient-to-b from-[#1e3a5f] to-[#162d4a] text-white overflow-hidden relative" data-id="element-41">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-42">
        {/* Title */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-black tracking-tight text-center leading-tight mb-4" data-id="element-43">
          Sistema PRO:
          <br data-id="element-44" />
          <span className="text-[#d4a017]" data-id="element-45">Cero Persecución</span>
        </h1>

        {/* Product Image - Below title */}
        <div className="flex justify-center mb-8" data-id="element-46">
          <div className="relative group cursor-pointer max-w-md w-full" onClick={scrollToPricing} data-id="element-47">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#d4a017] to-amber-300 rounded-2xl blur opacity-20 group-hover:opacity-40 transition duration-500" data-id="element-48"></div>
            <img src="https://cdn.magicpatterns.com/uploads/h94yRdPGn27MqAbgRNcoaV/Mockup_contadores-Photoroom.png" alt="Sistema PRO: Cero Persecución - Mockup del producto" className="relative w-full object-contain drop-shadow-2xl transform transition-transform duration-500 group-hover:scale-[1.03]" data-id="element-49" />
          </div>
        </div>

        {/* Subtitle */}
        <p className="text-lg md:text-xl text-gray-300 text-center leading-relaxed max-w-2xl mx-auto font-light mb-6" data-id="element-50">
          El sistema que permite a los contadores lograr que sus clientes manden
          la documentación a tiempo…{' '}
          <strong className="text-white font-bold" data-id="element-51">
            sin tener que perseguir a nadie.
          </strong>
        </p>

        {/* CTA */}
        <div className="flex justify-center mb-6" data-id="element-52">
          <Button onClick={scrollToPricing} className="text-base md:text-lg px-8 py-4" data-id="element-53">
            👉 Acceder al Sistema PRO ahora
          </Button>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs md:text-sm text-gray-400 font-medium mb-8" data-id="element-54">
          <div className="flex items-center" data-id="element-55">
            <ShieldCheckIcon className="w-4 h-4 text-green-400 mr-1.5" data-id="element-56" />
            Pago seguro
          </div>
          <div className="flex items-center" data-id="element-57">
            <ZapIcon className="w-4 h-4 text-yellow-400 mr-1.5" data-id="element-58" />
            Acceso inmediato
          </div>
          <div className="flex items-center" data-id="element-59">
            <FileTextIcon className="w-4 h-4 text-blue-400 mr-1.5" data-id="element-60" />
            PDF imprimible
          </div>
          <div className="flex items-center" data-id="element-61">
            <LockIcon className="w-4 h-4 text-red-400 mr-1.5" data-id="element-62" />
            Garantía 7 días
          </div>
        </div>

        {/* Rating badge */}
        <div className="flex justify-center" data-id="element-63">
          <div className="inline-flex items-center space-x-1 bg-white/10 rounded-full px-4 py-1.5 border border-white/20" data-id="element-64">
            <span className="flex text-[#d4a017]" data-id="element-65">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-current" data-id="element-66" />)}
            </span>
            <span className="text-xs font-medium ml-1.5" data-id="element-67">
              4.9/5 — Elegido por más de 500 contadores en Argentina
            </span>
          </div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="absolute top-0 right-0 -mr-40 -mt-40 w-80 h-80 rounded-full bg-[#d4a017] opacity-10 blur-3xl" data-id="element-68"></div>
      <div className="absolute bottom-0 left-0 -ml-40 -mb-40 w-80 h-80 rounded-full bg-blue-500 opacity-10 blur-3xl" data-id="element-69"></div>
    </section>;
}